import i18next from './i18next';

export default i18next;


//////////////////
// WEBPACK FOOTER
// ../~/i18next/dist/es/index.js
// module id = ../node_modules/i18next/dist/es/index.js
// module chunks = 0 1